import { BarChart3 } from 'lucide-react';

import { WidgetLayout } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';

export function Layout({
  children,
  className,
  fallback,
}: {
  children: React.ReactNode;
  className?: string;
  fallback?: React.ReactNode;
}) {
  return (
    <WidgetLayout
      title={dashboardWidgetsPermissionConfig['quick_companies_overview'].name}
      icon={BarChart3}
      viewAllLink="/companies"
      viewAllText="View All Companies"
      className={className}
      fallback={fallback}
    >
      {children}
    </WidgetLayout>
  );
}
